<template>
  <div class="trailer text-xs-center">
    <v-dialog
      v-model="dialog"
      :disabled="!videoId"
      width="1000"
    >
      <v-btn
        slot="activator"
        fab
        small
        class="mx-2"
        :class="pointerEvents"
        :disabled="!videoId"
        color="blue-grey darken-1"
        @click="loadIframe"
      >
        <v-icon>play_arrow</v-icon>
      </v-btn>

      <v-card>
        <v-card-actions class="pa-0 blue-grey darken-2">
          <v-spacer />
          <v-btn
            dark
            flat
            @click="closeTailer"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>

        <section
          v-if="startToLoad"
          class="trailer__wrap"
        >
          <iframe
            ref="iframe"
            class="trailer__iframe"
            :src="`https://www.youtube.com/embed/${videoId}?rel=0`"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          />
        </section>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
      startToLoad: false,
    };
  },
  computed: {
    pointerEvents() {
      let pointerEvent = '';
      if (this.videoId === false) {
        pointerEvent = 'no-events';
      }
      return pointerEvent;
    },
  },
  watch: {
    dialog() {
      if (this.$refs.iframe) {
        const { iframe } = this.$refs;
        const iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
    },
  },
  methods: {
    closeTailer() {
      this.dialog = false;
    },
    loadIframe() {
      this.startToLoad = true;
    },
  },

};
</script>

<style lang="scss">

.trailer {

  &__wrap {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
  }

  &__iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

}

</style>
